/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/models/content.rb
 */
import { MtContentData } from './Content';
import { StorageProviderMTPickers } from './Integrations/StorageProviders';

enum ContentType {
  AUDIO = 'audio',
  DOCUMENT = 'document',
  EMBEDDABLE = 'embeddable',
  IMAGE = 'image',
  TEXT = 'text',
  URL = 'url',
  VIDEO = 'video',
}

export const isContentDownloadable = (type: ContentType) =>
  [ContentType.DOCUMENT, ContentType.IMAGE].includes(type);

const MENTIONABLE_URL_PROVIDERS = [
  StorageProviderMTPickers.CallAi,
  StorageProviderMTPickers.AssetHub,
];

export const isContentNotMentionable = (
  type: ContentType,
  mtData?: MtContentData
): boolean => {
  if (type === ContentType.URL && mtData?.provider) {
    if (
      MENTIONABLE_URL_PROVIDERS.includes(
        mtData.provider as StorageProviderMTPickers
      )
    ) {
      return false;
    }
  }
  return [ContentType.URL, ContentType.EMBEDDABLE].includes(type);
};

export default ContentType;
